// src/pages/synthesize/components/AnglePicker.jsx
import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const PRESETS = [
  { key: 'key_insight',     icon: 'Lightbulb',     label: 'Key insight + my take', description: 'Lead with the most important idea; add why it matters.' },
  { key: 'agree_amplify',   icon: 'CheckCircle',   label: 'Agree and amplify',     description: 'Endorse the article; add an example or extension.' },
  { key: 'disagree',        icon: 'AlertCircle',   label: 'Respectful disagreement', description: 'Open with where you see it differently and why.' },
  { key: 'surprising',      icon: 'Sparkles',      label: 'Surprising takeaway',   description: 'Lead with the most counter-intuitive claim.' },
  { key: 'question_premise',icon: 'HelpCircle',    label: 'Question the premise',  description: 'Reframe the article as a discussion-worthy question.' },
];

const PURPLE = '#A78BFA';

export default function AnglePicker({ value, onChange, freeformText, onFreeformChange }) {
  const [showCustom, setShowCustom] = useState(value === 'freeform');

  useEffect(() => {
    if (value === 'freeform') setShowCustom(true);
  }, [value]);

  const select = (key) => {
    onChange(key);
    if (key === 'freeform') setShowCustom(true);
    else setShowCustom(false);
  };

  return (
    <div className="space-y-3">
      <label className="block text-sm font-semibold text-foreground">
        Your angle <span className="text-muted-foreground font-normal">(required)</span>
      </label>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {PRESETS.map((p) => {
          const active = value === p.key;
          return (
            <button
              key={p.key}
              type="button"
              onClick={() => select(p.key)}
              className={`group flex items-start gap-3 px-4 py-3 bg-card border rounded-xl text-left transition-all duration-200 ${
                active ? 'border-[#A78BFA]' : 'border-border hover:border-muted-foreground/40'
              }`}
            >
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${PURPLE}15` }}
              >
                <Icon name={p.icon} size={16} color={PURPLE} />
              </div>
              <div className="min-w-0">
                <div className="text-sm font-medium text-foreground">{p.label}</div>
                <div className="text-xs text-muted-foreground mt-0.5 leading-snug">{p.description}</div>
              </div>
            </button>
          );
        })}

        <button
          type="button"
          onClick={() => select('freeform')}
          className={`group flex items-start gap-3 px-4 py-3 bg-card border rounded-xl text-left transition-all duration-200 ${
            value === 'freeform' ? 'border-[#A78BFA]' : 'border-border hover:border-muted-foreground/40'
          }`}
        >
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: `${PURPLE}15` }}
          >
            <Icon name="Edit3" size={16} color={PURPLE} />
          </div>
          <div className="min-w-0">
            <div className="text-sm font-medium text-foreground">Custom angle</div>
            <div className="text-xs text-muted-foreground mt-0.5 leading-snug">Describe your own take in one sentence.</div>
          </div>
        </button>
      </div>

      {showCustom && (
        <div className="pt-1">
          <input
            type="text"
            value={freeformText || ''}
            onChange={(e) => onFreeformChange(e.target.value)}
            placeholder="e.g. I think this is overhyped because…"
            maxLength={280}
            className="w-full px-3 py-2.5 bg-card border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-[#A78BFA] transition-colors"
          />
          <div className="text-xs text-muted-foreground mt-1">{(freeformText || '').length}/280</div>
        </div>
      )}
    </div>
  );
}
